import { render, staticRenderFns } from "./ios-to-instructions.vue?vue&type=template&id=f4d751a4&scoped=true&"
import script from "./ios-to-instructions.vue?vue&type=script&lang=js&"
export * from "./ios-to-instructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d751a4",
  null
  
)

export default component.exports